import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b369c02"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, " Choose an audio file. ", -1))
const _hoisted_2 = { name: "audioForm" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "recording--text" }, "Recording:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayAudio = _resolveComponent("PlayAudio")!
  const _component_IonIcon = _resolveComponent("IonIcon")!
  const _component_IonLabel = _resolveComponent("IonLabel")!
  const _component_IonButton = _resolveComponent("IonButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", _hoisted_2, [
      (_ctx.recordedFile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "recorded--audio",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.playAudio.$el.click()))
            }, [
              _hoisted_4,
              _createVNode(_component_PlayAudio, {
                rawFile: _ctx.recordedFile,
                ref: "playAudio"
              }, null, 8, ["rawFile"])
            ]),
            _createVNode(_component_IonButton, {
              onClick: _ctx.finalizeRecording,
              expand: "block"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IonIcon, { icon: _ctx.cloudUpload }, null, 8, ["icon"]),
                _createVNode(_component_IonLabel, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Upload Recording")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_ctx.isRecording)
          ? (_openBlock(), _createBlock(_component_IonButton, {
              key: 1,
              onClick: _ctx.endAudioRecording
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IonIcon, { icon: _ctx.micOffCircleOutline }, null, 8, ["icon"]),
                _createVNode(_component_IonLabel, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Stop Recording Audio")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (!_ctx.isBrowser)
            ? (_openBlock(), _createBlock(_component_IonButton, {
                key: 2,
                onClick: _ctx.beginAudioRecording
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IonIcon, { icon: _ctx.micCircleOutline }, null, 8, ["icon"]),
                  _createVNode(_component_IonLabel, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Record Audio")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
      _createVNode(_component_IonButton, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.audioInput.click())),
        color: _ctx.isBrowser ? 'primary' : 'secondary'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_IonIcon, { icon: _ctx.musicalNotesOutline }, null, 8, ["icon"]),
          _createVNode(_component_IonLabel, null, {
            default: _withCtx(() => [
              _createTextVNode("Upload " + _toDisplayString(_ctx.isBrowser ? '' : 'Existing ') + "Audio File", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["color"]),
      _createElementVNode("input", {
        type: "file",
        hidden: "",
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.uploadAudio($event))),
        ref: "audioInput",
        accept: "audio/*"
      }, null, 544)
    ]),
    _createVNode(_component_IonButton, {
      class: "select-image--return",
      color: "secondary",
      fill: "outline",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dismiss()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IonIcon, { icon: _ctx.returnDownBackOutline }, null, 8, ["icon"]),
        _createTextVNode(" Done ")
      ]),
      _: 1
    })
  ], 64))
}